import { render, staticRenderFns } from "./Admin-Goods-Created.vue?vue&type=template&id=21b314f2&"
import script from "./Admin-Goods-Created.vue?vue&type=script&lang=js&"
export * from "./Admin-Goods-Created.vue?vue&type=script&lang=js&"
import style0 from "./Admin-Goods-Created.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports